class FostrMegaMenu extends HTMLElement {
  constructor() {
    super();

    // Elements
    this.section = this.closest('.shopify-section');
    this.menuItems = this.querySelectorAll('nav > ul > li');

    // Event listeners
    this.section.addEventListener('mouseleave', this.onLeaveSection.bind(this));
    this.menuItems.forEach(menuItem => {
      menuItem.addEventListener('mouseenter', this.onHoverMenuItem.bind(this));
      menuItem.addEventListener('onfocus', this.onHoverMenuItem.bind(this));
    });
  }

  onHoverMenuItem(event) {
    const submenu = event.currentTarget.querySelector('.fostr-mega-menu__submenu');

    this.closeSubmenus();

    if (submenu) {
      this.closeDisclosures();
      this.openSubmenu(submenu);
    }
  }

  onLeaveSection(event) {
    this.closeSubmenus();
  }

  openSubmenu(submenu) {
    const menuItem = submenu.closest('.has-submenu').querySelector('a');
    const header = document.getElementById('shopify-section-hera-header');
    if (menuItem) {
      menuItem.setAttribute('aria-expanded', true);
    }

    header.classList.add('header-hovered');
    document.body.classList.add('menu-open');
    submenu.classList.add('is-visible');
    submenu.removeAttribute('tabindex');
    submenu.setAttribute('aria-hidden', false);
  }

  closeSubmenu(submenu) {
    const menuItem = submenu.closest('.has-submenu').querySelector('a');
    const header = document.getElementById('shopify-section-hera-header');
    if (menuItem) {
      menuItem.setAttribute('aria-expanded', false);
    }

    header.classList.remove('header-hovered');
    document.body.classList.remove('menu-open');
    submenu.classList.remove('is-visible');
    submenu.setAttribute('tabindex', '-1');
    submenu.setAttribute('aria-hidden', true);
  }

  closeSubmenus() {
    const submenus = this.querySelectorAll('.fostr-mega-menu__submenu');
    submenus.forEach(submenu => this.closeSubmenu(submenu));
  }

  closeDisclosures() {
    const disclosures = this.querySelectorAll('details-disclosure');
    disclosures.forEach(disclosure => disclosure.close());
  }
}

customElements.define('fostr-mega-menu', FostrMegaMenu);